<template>
  <div class="auth-container">
    <h2>{{ isRegistering ? 'Register' : 'Login' }}</h2>
    <form @submit.prevent="submitForm">
      <!-- Registration-only fields -->
      <div v-if="isRegistering">
        <label>Full Name:</label>
        <input v-model="form.fullName" type="text" required />
      </div>
      <div>
        <label>Email:</label>
        <input v-model="form.email" type="email" required />
      </div>
      <div v-if="isRegistering">
        <label>Username:</label>
        <input v-model="form.username" type="text" required />
      </div>
      <div>
        <label>Password:</label>
        <input v-model="form.password" type="password" required />
      </div>
      <!-- Forgot Password button, only shown when in login mode -->
      <div v-if="!isRegistering" style="margin-top: 10px;">
        <button type="button" class="forgot-password" @click="goToResetPassword">
          Forgot Password?
        </button>
      </div>
      <div v-if="isRegistering">
        <label>Zip Code:</label>
        <input v-model="form.zipCode" type="text" required />
      </div>
      <div v-if="isRegistering">
        <label>Skill Level:</label>
        <select v-model="form.skillLevel" required>
          <option disabled value="">Select skill level</option>
          <option>Beginner</option>
          <option>Intermediate</option>
          <option>Expert</option>
          <option>Service Technician</option>
        </select>
      </div>
      <button type="submit">{{ isRegistering ? 'Register' : 'Login' }}</button>
    </form>
    <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    <p class="toggle" @click="toggleAuthMode">
      {{ isRegistering ? 'Already have an account? Login here.' : "Don't have an account? Register here." }}
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      isRegistering: true,
      form: {
        fullName: '',
        email: '',
        username: '',
        password: '',
        zipCode: '',
        skillLevel: ''
      },
      errorMessage: ''
    };
  },
  methods: {
    ...mapActions(['login']),
    toggleAuthMode() {
      this.isRegistering = !this.isRegistering;
      this.errorMessage = '';
      this.form = {
        fullName: '',
        email: '',
        username: '',
        password: '',
        zipCode: '',
        skillLevel: ''
      };
    },
    goToResetPassword() {
      // Navigate to the Reset Password page using Vue Router
      this.$router.push({ name: 'ResetPassword' });
    },
    async submitForm() {
      this.errorMessage = '';
      const endpoint = this.isRegistering ? '/api/register' : '/api/login';
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.form)
        });
        const data = await response.json();
        if (!response.ok) {
          this.errorMessage = data.error || 'An error occurred';
          return;
        }
        alert(data.message || 'Success!');
        if (!this.isRegistering) {
          this.login(data.user);
          console.log("User in localStorage:", localStorage.getItem('user'));
          window.location.href = '/';
        }
      } catch (error) {
        this.errorMessage = error.message;
      }
    }
  }
};
</script>

<style scoped>
.auth-container {
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
}
.auth-container label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}
.auth-container input,
.auth-container select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
button {
  margin-top: 15px;
  padding: 10px;
  width: 100%;
  border: none;
  background: #f4a261;
  color: #000;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background: #e0884d;
}
.forgot-password {
  background: transparent;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}
.error {
  color: red;
  margin-top: 10px;
}
.toggle {
  margin-top: 15px;
  text-align: center;
  color: #007bff;
  cursor: pointer;
}
.toggle:hover {
  text-decoration: underline;
}
</style>
